import { SiteConfig } from '@jd/platform-config';
import { DeepNullToUndefined } from '@jd/client/utils/unnulable';
import { TestimonialTexts } from './type';

type Input = DeepNullToUndefined<SiteConfig['reviews']>;

/** Texts are prefilled in the Reviews tab of the site configuration. */
export const textsMapper = (input: Input): TestimonialTexts => ({
  questions: input?.questions,
  buttons: {
    recordVideo: input?.buttons?.recordVideo ?? '',
    googleReview: input?.buttons?.googleReview ?? '',
  },
  recording: {
    helpText: input?.recording?.helpText,
    startRecording: input?.recording?.startRecording ?? '',
    uploadFile: input?.recording?.uploadFile ?? '',
    questionsTitle: input?.recording?.questionsTitle ?? '',
    next: input?.recording?.next ?? '',
    missingPermission: input?.recording?.missingPermission ?? '',
  },
  form: {
    name: input?.form?.name ?? '',
    email: input?.form?.email ?? '',
    company: input?.form?.company ?? '',
    social: input?.form?.social ?? '',
    consent: input?.form?.consent,
    consentRequired: input?.form?.consentRequired ?? '',
    submit: input?.form?.submit ?? '',
    uploading: input?.form?.uploading ?? '',
    error: input?.form?.error ?? '',
  },
  thankYou: {
    title: input?.thankYou?.title ?? '',
    close: input?.thankYou?.close ?? '',
  },
});
